/**
 * @module util/portPicker/constants
 * Shared enums + tuning for the smart location/port picker (PRD §6). Frozen objects so
 * they read like enums and lend themselves to a later TS migration.
 */

/** What kind of place the user picked — drives icon, grouping, and resolution. */
export const PlaceKind = Object.freeze({
  SEAPORT: 'SEAPORT', // exact PF ocean port (Company)      → anchor icon
  AIRPORT: 'AIRPORT', // exact PF airport (Airports)        → plane icon
  AIR_CITY: 'AIR_CITY', // city group (shared cityIden)     → plane icon, expands
  GEO_PLACE: 'GEO_PLACE', // generic Google place / address → pin icon
});

/** Search mode — only changes the picker's data source, icon, and grouping. */
export const ShipmentMode = Object.freeze({ OCEAN: 'ocean', AIR: 'air' });

/** Icon hint per place kind; the component maps these to actual glyphs. */
export const PLACE_ICON = Object.freeze({
  [PlaceKind.SEAPORT]: 'anchor',
  [PlaceKind.AIRPORT]: 'plane',
  [PlaceKind.AIR_CITY]: 'plane',
  [PlaceKind.GEO_PLACE]: 'pin',
});

/** Nearest-port resolver defaults (overridable per call / via env later). */
export const NEAREST_DEFAULTS = Object.freeze({
  metroKm: 100, // tier-0 "same metro" radius
  maxNearest: 3, // cap candidate ports per side
  maxLanePairs: 9, // cap origin×destination lane combinations (MAX_NEAREST²)
});

/** Geographic tier for a resolved candidate (lower = closer / preferred). */
export const GeoTier = Object.freeze({ METRO: 0, COUNTRY: 1, OTHER: 2 });
